/**
 * buildOptimizeQueryCtx / buildExplainErrorCtx — pure `AiTaskContext` builders
 * for QueryEditorTab's two T13 AI task launchers.
 *
 * Extracted out of the component (fix-round-T13-r1.md, I-1) so the wave's one
 * hard-won correctness invariant — `ctx.tabId` always travels with a launch
 * fired from a query tab, so `findExistingQueryTab` never falls back to
 * first-match and lands on a sibling tab's buffer — is pinned by a unit test
 * on the object these functions return, not just on the mechanism that reads
 * it (`openAiChatWithTask.test.ts` already covered that half; the call site
 * that has to *feed* `tabId` in was the part with zero coverage).
 *
 * `tabId` is a required, non-optional parameter on both — dropping it at the
 * call site is a type error, not a silent `undefined`.
 */

import type { AiTaskContext } from '../../../ai-chat/launchers/launcherRegistry';

export function buildOptimizeQueryCtx(
  connectionId: string,
  database: string | undefined,
  tabId: string
): AiTaskContext {
  return { connectionId, database, tabId };
}

export function buildExplainErrorCtx(
  connectionId: string,
  database: string | undefined,
  tabId: string,
  errorText: string
): AiTaskContext {
  return { connectionId, database, tabId, errorText };
}
